module.exports = __webpack_public_path__ + "img/utc2d_green.a9d3c860.png";